import React from 'react'
// import cover from "../images/cover2.jpg"

export default function Home() {
  return (
    <div className='w-full h-full cover  relative'>
      
    </div>
    
  )
}
